module.exports = __webpack_public_path__ + "img/1565335566.5f31b6c6.jpg";